module.exports = __webpack_public_path__ + "img/juegos.e898b841.svg";